export default __webpack_public_path__ + "static/media/activitytab-alerts.af0cacfe.svg";